import { render } from "./StaffList.vue?vue&type=template&id=722997cf"
import script from "./StaffList.vue?vue&type=script&lang=js"
export * from "./StaffList.vue?vue&type=script&lang=js"

import "./StaffList.vue?vue&type=style&index=0&id=722997cf&lang=scss"
script.render = render

export default script